import { observer } from 'mobx-react'
import './index.scss'
import GlobalState, {
  changeCountriesState,
} from '../../../../stores/GlobalState'
import { ReactComponent as Logo } from '../../../../assets/logo.svg'
import { ReactComponent as Close } from '../../../../assets/close.svg'
import classNames from 'classnames'
import { Fragment, useEffect } from 'react'
import ContentState from '../../../../stores/ContentState'

const CountriesBurger = observer(() => {
  useEffect(() => {
    if (GlobalState.isCountriesOpen) {
      document.querySelector('body, html, #root')?.classList.add('hidden-menu')
    } else
      document
        .querySelector('body, html, #root')
        ?.classList.remove('hidden-menu')
  }, [GlobalState.isCountriesOpen])

  return (
    <section
      className={classNames('countries', GlobalState.isCountriesOpen && 'open')}
      onClick={changeCountriesState}
    >
     <div
        className="countries__container"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="countries__top">
          <div className="countries__title">
            {ContentState.about?.offices
              ? ContentState.about?.offices[0].title
              : ''}
          </div>
          <div className="countries__close" onClick={changeCountriesState}>
            <Close />
          </div>
        </div>
        <div className="countries__block">
          {ContentState.about?.offices.map((c, i) => (
            <Fragment key={i}>
              {i ? <div className="countries__subtitle">{c.title}</div> : <></>}
              <ul className="countries__list">
                {c.list?.map((ci, id) => (
                  <li className="countries__item" key={id}>
                    <span>
                      <img src={ci.icon} alt="" />
                    </span>
                    <div>{ci.text}</div>
                  </li>
                ))}
              </ul>
            </Fragment>
          ))}
        </div>
      </div>
    </section>
  )
})

export default CountriesBurger
